exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-box[data-v-8ea8061e]{min-height:calc(100vh - 77px)}.table-box[data-v-8ea8061e] .el-table th{background-color:#f7fbff}\n", ""]);

// exports
